
<template>
    <div
        class="divStyle">
        <iframe 
        :src="url" 
        allowfullscreen 
        frameborder="0"
        class="iframeStyle"
        >
        </iframe>
    </div>
</template>
<script>
export default {
  props: {
    url: String,
  },
};
</script>
<style>
.divStyle {
  overflow: hidden;
  bottom: 15px;
}
.iframeStyle {
  top: 10%;
  min-height: 80vh;
  width: 100%;
}
</style>
